// Admin match TV — sky99 client ka hi player, EK hi URL: https://sky99.co/tv/<matchId>
// (client match page jaisa hi flow: hls-start -> direct GLIVE / mhls -> ping). Admin me
// alag player copy nahi — client me jo fix/sudhaar ho, yahan apne aap aa jaata hai.
export const MATCH_TV_URL = "https://sky99.co/tv";

const MatchTvPlayer = ({ matchId, matchName }) => {
  const src = `${MATCH_TV_URL}/${encodeURIComponent(matchId)}${matchName ? `?name=${encodeURIComponent(matchName)}` : ""}`;
  return (
    <div className="relative bg-black" style={{ aspectRatio: "16 / 9", maxHeight: 360 }}>
      <iframe
        src={src}
        title="Live TV"
        className="absolute inset-0 w-full h-full"
        style={{ border: 0 }}
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default MatchTvPlayer;
